let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jSldJ")).then(() => parcelRequire('2SdkN'));